(() => {
(function() {
    'use strict';
    function isPauseVideoError(error) {
        return error && error.message && error.message.indexOf('pauseVideo') !== -1;
    }
    function triggerLayoutRecalculation() {
        // Trigger layout recalculation for Essential Grid
        window.dispatchEvent(new Event('resize'));
        if (typeof jQuery !== 'undefined') jQuery(window).trigger('resize');
    }
    // Fix 1: Wrap jQuery.ajax success callbacks (handles Load More button)
    if (typeof jQuery !== 'undefined') {
        const $ = jQuery;
        const originalAjax = $.ajax;
        $.ajax = function(settings) {
            const originalSuccess = settings.success;
            if (typeof originalSuccess === 'function') settings.success = function(data, status, xhr) {
                try {
                    const result = originalSuccess.call(this, data, status, xhr);
                    // After AJAX completes, wait a bit for images to start loading,
                    // then trigger layout recalculation to fix the Masonry grid
                    setTimeout(()=>{
                        triggerLayoutRecalculation();
                    }, 100);
                    return result;
                } catch (error) {
                    if (!isPauseVideoError(error)) throw error;
                }
            };
            return originalAjax.call(this, settings);
        };
    }
    // Fix 2: Wrap IntersectionObserver callbacks (handles lazy load / quickdraw)
    if (typeof window.IntersectionObserver !== 'undefined') {
        const OriginalIO = window.IntersectionObserver;
        window.IntersectionObserver = function(callback, options) {
            const wrappedCallback = function(entries, observer) {
                try {
                    return callback(entries, observer);
                } catch (error) {
                    if (!isPauseVideoError(error)) throw error;
                }
            };
            return new OriginalIO(wrappedCallback, options);
        };
        window.IntersectionObserver.prototype = OriginalIO.prototype;
    }
    // Fix 3: Trigger layout recalculation after all page resources are loaded.
    // Essential Grid calculates Masonry positions early, before fonts and other
    // resources affect layout. A resize event forces it to recalculate correctly.
    // Only runs if an Essential Grid is present on the page.
    window.addEventListener('load', function() {
        var hasGrid = document.querySelector('.esg-grid');
        if (!hasGrid) return;
        triggerLayoutRecalculation();
    });
})();

})();
//# sourceMappingURL=essential-grid-fix.js.map
